import HistoryIcon from '@mui/icons-material/History';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

const PatientHistoryGroup = ({ group }) => {
  const firstName = group.pomUserFirstName?.trim() || '';
  const lastName = group.pomUserLastName?.trim() || '';
  const displayName =
    firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName || 'N/A';

  return (
    <Box
      sx={{
        position: 'relative',
        pl: 6,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: 12,
          top: 8,
          width: 18,
          height: 18,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1,
        }}
      >
        <HistoryIcon sx={{ fontSize: 12, color: 'white' }} />
      </Box>

      <Box sx={{ mb: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, flexWrap: 'wrap' }}>
          <Typography
            component='span'
            variant='body1'
            sx={{ fontWeight: 'bold', fontSize: '1.05rem', lineHeight: 1.2 }}
          >
            {displayName}
          </Typography>
          {group.actorRole ? (
            <Typography
              component='span'
              variant='caption'
              sx={{ color: 'text.disabled', fontSize: '0.75rem', lineHeight: 1.2 }}
            >
              {group.actorRole}
            </Typography>
          ) : null}
        </Box>
        <Typography variant='caption' color='text.secondary'>
          {group.items[0]?.createdTimestamp
            ? format(new Date(group.items[0].createdTimestamp), 'MMM dd, yyyy hh:mm a')
            : 'N/A'}
        </Typography>
      </Box>

      <Box
        sx={{
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 2,
        }}
      >
        <Box sx={{ position: 'relative', pl: 4 }}>
          <Box
            sx={{
              position: 'absolute',
              left: 8,
              top: 0,
              bottom: 0,
              width: 2,
              bgcolor: 'divider',
            }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {group.items.map((gi) => (
              <Box key={gi.auditEventId} sx={{ position: 'relative' }}>
                <Box
                  sx={{
                    position: 'absolute',
                    left: -12,
                    top: 4,
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                    border: '2px solid',
                    borderColor: 'background.paper',
                    zIndex: 1,
                  }}
                />
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'baseline' }}>
                  <Typography variant='body1'>
                    {gi.description || 'No description available'}
                  </Typography>
                  <Typography variant='caption' color='text.secondary'>
                    {gi.createdTimestamp
                      ? format(new Date(gi.createdTimestamp), 'MMM dd, yyyy hh:mm a')
                      : 'N/A'}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

PatientHistoryGroup.propTypes = {
  group: PropTypes.shape({
    pomUserFirstName: PropTypes.string,
    pomUserLastName: PropTypes.string,
    actorRole: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        auditEventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        description: PropTypes.string,
        createdTimestamp: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
};

export default PatientHistoryGroup;
